import { globals } from "@client/globals";
import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { addQueryParameters } from "@common/lib/api";
import classnames from "classnames";
import * as React from "react";
import "./style.less";

export type ImageProps = React.HTMLProps<HTMLDivElement> & {
  color?: string;
  src: string;
  tooltip?: string;

  onImageLoaded?: () => void;
};

const Image = React.forwardRef<HTMLDivElement, ImageProps>(
  ({ className, src, onImageLoaded, tooltip, ...props }: ImageProps, ref: React.RefObject<HTMLDivElement>) => (
    <div ref={ref} className={classnames("wsc_image", className)} {...props} {...getTooltipAttributes(tooltip)}>
      {src.indexOf("icons.svg") >= 0 ? (
        <svg style={{ color: props.color }}>
          <use href={addQueryParameters(src, { v: globals.version })} />
        </svg>
      ) : (
        <img src={src} onLoad={onImageLoaded} />
      )}
    </div>
  )
);

export default Image;
